import React, {useState, useEffect} from "react";
import { isDeviceConnected, isStreamingConnected } from '../lib/connectionStatus';

export default function ConnectionState(props) {
    const [node, setNode] = useState(props.node);
    const [stateConnection, setStateConnection] = useState("waitData");
    const [secsFromLastData, setSecsFromLastData] = useState(0);

    useEffect(() => {
        setNode(props.node);

        const pointTime = props.node?.point?.time;
        const connected = isDeviceConnected(pointTime);
        const streamingConnected = isStreamingConnected(pointTime);

        setStateConnection(connected ? "Connected" : "lostConnection");
        props.setLinkStatus(connected ? "CONNECTED" : "LOST");
        props.setLinkStatusStreaming(streamingConnected ? "CONNECTED" : "LOST");
        setSecsFromLastData(0);
    }, [props.node]);

    return (<div>
        {/*{stateConnection}({secsFromLastData.toFixed(0)}))*/}

    </div>);
}
